// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1[data-v-1343d0e1]{fill:var(--v-primary-base)}.cls-2[data-v-1343d0e1]{fill:#febf7c}.cls-3[data-v-1343d0e1],.cls-4[data-v-1343d0e1]{fill:#fff}.cls-4[data-v-1343d0e1]{font-size:16px;font-family:SegoeUI-Semibold,Segoe UI;font-weight:600}", ""]);
// Exports
module.exports = exports;
